import React from 'react'
import PropTypes from 'prop-types'
import MutationManager from './Mutation'
import gql from 'graphql-tag'

/**
 * [REMOVE_ORDER_ITEM] Example Input
 * {
    "payload": {
      "idOrder": "123456-7",
      "itemSku": "123458"
    }
  }
 */

const REMOVE_ORDER_ITEM = gql`mutation removeOrderItem($payload: OrderItemInput) {
  removeOrderItem(input: $payload) {
    message
    status
  }
}
`

const updatePayload = ({ id, sku, salesChannelId }) => {
  const reqPayload = { variables: { payload: { orderId: id, itemSku: sku, salesChannelId } } }
  return reqPayload
}

const RemoveOrderItem = ({ children, ...props }) => {
  return (
    <MutationManager mutation={REMOVE_ORDER_ITEM} onCompleted={()=> props.refetchQueries()} refetchQueries={['getOrderById', 'getOrderItems', 'getPickingInfoBy']}>
      {({ data, loading, updateFn }) => children({ updateFn: (values) => (updateFn(updatePayload(values))), loading, ...props })}
    </MutationManager>
  )
}

RemoveOrderItem.propTypes = {
  children: PropTypes.any,
  RemoveOrderItem: PropTypes.func
}

export default RemoveOrderItem;
